import hasLength from '../hasLength';
import * as R from 'ramda';

const PatientEnrollmentStates = {
    NEVER_SUBMITTED: 'NEVER_SUBMITTED',
    UNCONFIRMED: 'UNCONFIRMED',
    SUBSCRIBED: 'SUBSCRIBED',
    DECLINED: 'DECLINED',
    UNSUBSCRIBED: 'UNSUBSCRIBED',
};

const isNilOrEmpty = R.anyPass([R.isEmpty, R.isNil]);
const isSubscribed = R.allPass([
    R.propEq(1, 'confirmed'),
    R.prop('subscribedOn'),
    R.propSatisfies(isNilOrEmpty, 'unsubscribedOn'),
]);
/**
 * Refer to this wiki for detailed subscription permutations and status mapping:
 * https://cpssolutions.atlassian.net/wiki/spaces/EN/pages/2251554819/Patient+Messaging+Statuses
 */
const isDeclined = R.allPass([
    R.propSatisfies(isNilOrEmpty, 'confirmed'),
    R.propSatisfies(isNilOrEmpty, 'subscribedOn'),
    R.propSatisfies(hasLength, 'unsubscribedOn'),
]);

//prettier-ignore
const isUnsubscibed = R.allPass([
    R.propEq(1, 'confirmed'),
    R.propSatisfies(hasLength, 'unsubscribedOn')
]);

function getPatientMessageEnrollmentStatus(subscription = null) {
    return R.cond([
        [R.isNil, R.always(PatientEnrollmentStates.NEVER_SUBMITTED)],
        [isSubscribed, R.always(PatientEnrollmentStates.SUBSCRIBED)],
        [isDeclined, R.always(PatientEnrollmentStates.DECLINED)],
        [isUnsubscibed, R.always(PatientEnrollmentStates.UNSUBSCRIBED)],
        [R.T, R.always(PatientEnrollmentStates.UNCONFIRMED)],
    ])(subscription);
}

export { PatientEnrollmentStates };

export default getPatientMessageEnrollmentStatus;
